// extracted by mini-css-extract-plugin
module.exports = {"posts":"Posts_posts__OXW86","posts__container":"Posts_posts__container__5_dCD"};